import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

/* Stufenwechsel mit Regel R2 (v5/v6: „Kein Lead ohne nächsten Schritt").
   Statt einem nackten 422 fragt der Dialog das Fehlende ab:
   – verloren → Grund (Pflicht)
   – jede andere Stufe (außer abschluss/nachfassen) → nächster Schritt (was + fällig am)
   onBestaetigen(extra) bekommt { grund } bzw. { naechster_schritt: { was, faellig_am } }. */

function morgen9Uhr() {
  const d = new Date(); d.setDate(d.getDate() + 1); d.setHours(9, 0, 0, 0);
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}

export default function StufenwechselDialog({ offen, stufeLabel, verloren, hinweis, onBestaetigen, onAbbrechen }) {
  const [was, setWas] = useState('');
  const [faellig, setFaellig] = useState(morgen9Uhr());
  const [grund, setGrund] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (offen) { setWas(''); setFaellig(morgen9Uhr()); setGrund(''); setBusy(false); } }, [offen]);

  const ok = verloren ? grund.trim().length > 1 : (was.trim().length > 1 && !!faellig);
  const senden = async () => {
    if (!ok || busy) return;
    setBusy(true);
    try {
      await onBestaetigen(verloren ? { grund: grund.trim() } : { naechster_schritt: { was: was.trim(), faellig_am: new Date(faellig).toISOString() } });
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={offen} onOpenChange={(o) => { if (!o) onAbbrechen(); }}>
      <DialogContent className="sm:max-w-md" data-testid="stufenwechsel-dialog">
        <DialogHeader>
          <DialogTitle>{verloren ? 'Warum verloren?' : `Nächster Schritt für „${stufeLabel}"`}</DialogTitle>
          <DialogDescription>
            {verloren
              ? 'Ohne Grund lässt sich später nichts verbessern. Kurz reicht: preis, bedenkzeit, zeit, …'
              : (hinweis || 'Kein Statuswechsel ohne nächsten Schritt — was passiert als Nächstes, und bis wann?')}
          </DialogDescription>
        </DialogHeader>
        {verloren ? (
          <div className="space-y-1.5">
            <Label htmlFor="sw-grund">Grund</Label>
            <Input id="sw-grund" value={grund} onChange={(e) => setGrund(e.target.value)} autoFocus placeholder="z. B. preis, bedenkzeit, zeit" data-testid="sw-grund"
              onKeyDown={(e) => { if (e.key === 'Enter') senden(); }} />
          </div>
        ) : (
          <div className="space-y-3">
            <div className="space-y-1.5">
              <Label htmlFor="sw-was">Was</Label>
              <Input id="sw-was" value={was} onChange={(e) => setWas(e.target.value)} autoFocus placeholder="z. B. Probetraining vereinbaren, Angebot senden" data-testid="sw-was"
                onKeyDown={(e) => { if (e.key === 'Enter') senden(); }} />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="sw-faellig">Fällig am</Label>
              <Input id="sw-faellig" type="datetime-local" value={faellig} onChange={(e) => setFaellig(e.target.value)} data-testid="sw-faellig" />
            </div>
          </div>
        )}
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={onAbbrechen} disabled={busy}>Abbrechen</Button>
          <Button onClick={senden} disabled={!ok || busy} data-testid="sw-bestaetigen">{verloren ? 'Als verloren markieren' : 'Stufe wechseln'}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
